module.exports = __webpack_public_path__ + "img/bebidas-icon.20880e66.svg";